import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as styles from './characteristicSelect.css';

class CharacteristicSelect extends Component {
  constructor(props) {
    super(props);

    this.state = this.props;

    this.onChange = this.onChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps });
  }

  onChange(indicator, characteristic, hasData) {
    // Update the state of the characteristics upon changing one
    const characteristics = this.state.characteristics
      .map((item) => (characteristic === item.characteristic ?
        { ...item, checked: !item.checked } :
        { ...item }
      ));
    // Figure out which characteristics to deselect
    const toDeselect = characteristics
      .filter(({ checked }) => !checked)
      .map(({ characteristic: ch }) => ch);

    this.props.onChange(`${indicator}`, characteristic, toDeselect, hasData);
    this.setState({ characteristics });
  }

  render() {
    const { hasData, catHash } = this.props;
    const { characteristics, indicator } = this.state;
    const totalUnchecked = characteristics
      .filter(({ checked }) => !checked).length;

    return (
      <ul className={styles.container}>
        {characteristics.map((
          { characteristic, id, locked = false, checked }
        ) => {
          let compoundId = id;
          let compoundInd = indicator;
          if (catHash) {
            compoundId = `${id}|${catHash}`;
            compoundInd = `${indicator}|${catHash}`;
          }
          return (
            <li className={styles.item} key={compoundId}>
              <input
                className={styles.input}
                type="checkbox"
                id={compoundId}
                disabled={hasData &&
                  (
                    locked ||
                    1 === characteristics.length ||
                    (
                      // If this is the last checked characteristic,
                      // it needs to be disabled as the user must un-check
                      // the parent indicator.
                      totalUnchecked + 1 === characteristics.length &&
                        checked
                    )
                  )
                }
                onChange={() =>
                  this.onChange(compoundInd, characteristic, hasData)
                }
                checked={checked || locked}
              />
              <label htmlFor={compoundId}>{characteristic}</label>
            </li>
          );
        })}
      </ul>
    );
  }
}

CharacteristicSelect.defaultProps = {
  hasData: true,
  catHash: null,
};

CharacteristicSelect.propTypes = {
  characteristics: PropTypes.arrayOf( // eslint-disable-line react/no-unused-prop-types
    PropTypes.shape({
      characteristic: PropTypes.string.isRequired,
      locked: PropTypes.bool,
      id: PropTypes.string.isRequired,
    })
  ).isRequired,
  indicator: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
  catHash: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
  onChange: PropTypes.func.isRequired, // eslint-disable-line react/no-unused-prop-types
  hasData: PropTypes.bool,
};

/**
 * Check if a characteristic is in the router state.
 * If so, we do not want it checked.
 *
 * @param {any} item - the characteristic to check
 * @param {any} router - the router object
 * @returns boolean - states whether or not a characteristic is in router
 */
function inRouter(item, router, catHash) {
  if (catHash) {
    const fullInd = `${item.indicator}|${catHash}`;
    return router[fullInd] &&
    router[fullInd].distribution &&
    -1 < router[fullInd].distribution.indexOf(item.characteristic);
  }
  return router[item.indicator] &&
  router[item.indicator].distribution &&
  -1 < router[item.indicator].distribution.indexOf(item.characteristic);
}

const mapStateToProps = ({ router, table: { indicators } }, ownProps) => {
  const foundInd = indicators.find(({ id }) => id === ownProps.indicator);

  if (!foundInd) {
    return { };
  }

  const allCharacteristics = foundInd.data
    .reduce((acc, item) => (
      acc.every(({ characteristic }) =>
        characteristic !== item.characteristic
      ) ?
        acc.concat(item) :
        acc
    ), [])
    .map(({ characteristic, characteristicIdx }) => ({
      characteristic,
      locked: false,
      id: `${ownProps.indicator}-${characteristicIdx}`,
      indicator: ownProps.indicator,
    }))
    .reduce((acc, item) => {
      const active = ownProps.characteristics
        .find(({ characteristic: c }) => c === item.characteristic);
      if (active) {
        return acc.concat({ ...active, ...item });
      }
      return acc.concat(item);
    }, [])
    .map((item) => ({
      ...item,
      checked: (
        ownProps.selectAll ||
          (ownProps.hasData && !inRouter(item, router, ownProps.catHash))
      ) && !ownProps.deselectAll,
    }));

  return {
    characteristics: allCharacteristics,
  };
};

export default connect(mapStateToProps)(CharacteristicSelect);
export { CharacteristicSelect };



// WEBPACK FOOTER //
// ./app/components/characteristicSelect/index.js